module.exports = __webpack_public_path__ + "img/陈志鹏.11308831.jpg";